import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import { formatCard } from '../../../../../shared/helpers/formatCard';
import { formatPrice } from '../../../../../shared/helpers/formatPrice';
import { Stage } from '../../../../../types/bookings';
import { StyledDescriptionList } from '../../BookingInformation.styles';
import { StyledWrapper } from './BookingTenantPaymentInformation.styles';

interface BookingTenantPaymentInformationProps {
  bookingStage: Stage;
  bookingId: string;
  proposal: number;
  cardNumber: number;
}

const BookingTenantPaymentInformation = ({
  bookingStage,
  bookingId,
  proposal,
  cardNumber,
}: BookingTenantPaymentInformationProps) => {
  const { t } = useTranslation(['booking', 'common']);
  const updatePaymentInformationUrl = `${process.env.REACT_APP_SITE_URL}/bookings/change-payment-method/${bookingId}`;
  return (
    <StyledDescriptionList>
      <div>
        <dt>{upperFirst(t('booking:offer'))}</dt>
        <dd>{formatPrice(proposal)}</dd>
      </div>
      <div>
        <StyledWrapper>
          <dt>{upperFirst(t('booking:cardNumber'))}</dt>
          {bookingStage !== Stage.Draft && (
            <dt onClick={() => window.open(updatePaymentInformationUrl)}>
              {upperFirst(t('common:change'))}
            </dt>
          )}
        </StyledWrapper>
        <dd>{formatCard(cardNumber)}</dd>
      </div>
    </StyledDescriptionList>
  );
};

export default BookingTenantPaymentInformation;
